import styled from 'styled-components';
import { theme } from 'academy-common-lib/utils/Styling';
import { useHistory } from 'react-router-dom';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import { H1 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import { useGetToolRecommendations } from '../queries/softwareDiscoveryHooks';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import ToolRecommendationsForLearningContent from './ToolRecommendationsForLearningContent';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonsWrapper = styled(ContentControlWrapper).withConfig({
  displayName: "OptionalToolRecommendationSection__ButtonsWrapper",
  componentId: "sc-1nns1c6-0"
})(["display:flex;justify-content:flex-end;align-items:center;"]);
const SkipLink = styled(UIButton).withConfig({
  displayName: "OptionalToolRecommendationSection__SkipLink",
  componentId: "sc-1nns1c6-1"
})(["font-weight:500 !important;"]);
const OptionalToolRecommendationSection = ({
  contentName,
  useCases = [],
  nextLessonId,
  trackId,
  lessonId
}) => {
  const {
    push,
    location
  } = useHistory();
  const toolRecommendations = useGetToolRecommendations(useCases);
  const {
    recommendationTopic
  } = toolRecommendations || {};
  const onClickingNext = () => push(Object.assign({}, location, {
    pathname: `/tracks/${trackId}/${nextLessonId}`
  }));
  const onClickingSkip = () => push(Object.assign({}, location, {
    pathname: `/lessons/${lessonId}/recommendations`
  }));
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "optional-tool-recommendation-section",
    style: {
      backgroundColor: theme.colors.KOALA
    },
    children: [/*#__PURE__*/_jsx(UIRibbon, {
      className: "m-top-3",
      position: "left",
      style: {
        position: 'initial'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.recommendations.optionalSideNav.optionalStep"
      })
    }), /*#__PURE__*/_jsx(ToolRecommendationsForLearningContent, {
      cardWidth: 242,
      contentName: contentName,
      renderRecommendations: commonContent => {
        return /*#__PURE__*/_jsxs(UISection, {
          className: "p-all-10",
          children: [/*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            direction: "column",
            children: [/*#__PURE__*/_jsx(H1, {
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "learningCenter.tracks.recommendations.optionalSideNav.title",
                options: {
                  topic: recommendationTopic
                }
              })
            }), /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "learningCenter.tracks.recommendations.optionalSideNav.description",
                options: {
                  topic: recommendationTopic
                }
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            as: "div",
            marginBlock: "1000",
            children: commonContent
          })]
        });
      },
      toolsToDisplay: 3,
      useCases: useCases
    }), /*#__PURE__*/_jsx(ButtonsWrapper, {
      children: trackId ? /*#__PURE__*/_jsx(UIButton, {
        onClick: onClickingNext,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.next"
        })
      }) : /*#__PURE__*/_jsx(SkipLink, {
        onClick: onClickingSkip,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.linkContent.skip"
        })
      })
    })]
  });
};
export default OptionalToolRecommendationSection;